import { render, staticRenderFns } from "./Transports.vue?vue&type=template&id=16432a30&"
import script from "./Transports.vue?vue&type=script&lang=js&"
export * from "./Transports.vue?vue&type=script&lang=js&"
import style0 from "./Transports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports